import { render, staticRenderFns } from "./wxForm.vue?vue&type=template&id=b05a0b92&scoped=true&"
import script from "./wxForm.vue?vue&type=script&lang=js&"
export * from "./wxForm.vue?vue&type=script&lang=js&"
import style0 from "./wxForm.vue?vue&type=style&index=0&id=b05a0b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05a0b92",
  null
  
)

export default component.exports